import { render, staticRenderFns } from "./stu_sign.vue?vue&type=template&id=3edc235d&scoped=true&"
import script from "./stu_sign.vue?vue&type=script&lang=js&"
export * from "./stu_sign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edc235d",
  null
  
)

export default component.exports